import React from 'react'
import { Text } from '@shared/ui/atoms'

export const regionsWithRestrictionsInstructionSteps = [
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Выйди из&nbsp;Steam на&nbsp;всех устройствах (ПК, браузер)
      </Text>
    ),
  },
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Если ты&nbsp;в&nbsp;Крыму/ЛНР/ДНР: включи авиарежим на&nbsp;телефоне с&nbsp;Steam Guard
      </Text>
    ),
  },
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Смени сетевое расположение на&nbsp;РФ&nbsp;(лучше Москва/СПб) и&nbsp;зайди в&nbsp;Steam через браузер
      </Text>
    ),
  },
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Подожди 30&nbsp;минут перед оплатой
      </Text>
    ),
  },
  {
    content: (
      <Text family="MTSCompact" size={{ desktop: 'pL', mobile: 'pM' }} weight="medium" color="primary">
        Следующий платеж необходимо сделать не&nbsp;раньше чем через 2 часа
      </Text>
    ),
  },
]
